<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue'
import timeoutMixin from '@/utils/timeoutMixin'
export default {
  mixins: [timeoutMixin],
  data() {
    return {
      cdata: {
        category: [
          "2.1",
          "2.2",
          "2.3",
          "2.4",
          "2.5",
          "2.6",
          "2.7",
          "2.8",
          "2.9",
          "2.10",
          "2.11",
          "2.12",
          "2.13",
          "2.14",
          "2.15"
        ],
        lineData1: [
          8092,
          20728,
          54045,
          28348,
          52808,
          56097,
          49867,
          34715,
          28444,
          30415,
          46061,
          52677,
          69521,
          67560,
          48092
        ],
        lineData2: [
          18092,
          20728,
          24045,
          28348,
          32808,
          36097,
          39867,
          44715,
          48444,
          50415,
          56061,
          62677,
          59521,
          67560,
          18092
        ],
        lineData3: [
          4600,
          5000,
          5500,
          6500,
          7500,
          8500,
          9900,
          12500,
          14000,
          21500,
          23200,
          24450,
          25250,
          33300,
          4600
        ],
        rateData: []
      },
      data: [
        {
          lineData1: [
            8092,
            20728,
            54045,
            28348,
            52808,
            56097,
            49867,
            34715,
            28444,
            30415,
            46061,
            52677,
            69521,
            67560,
            48092
          ],
          lineData2: [
            18092,
            20728,
            24045,
            28348,
            32808,
            36097,
            39867,
            44715,
            48444,
            50415,
            56061,
            62677,
            59521,
            67560,
            18092
          ],
          lineData3: [
            4600,
            5000,
            5500,
            6500,
            7500,
            8500,
            9900,
            12500,
            14000,
            21500,
            23200,
            24450,
            25250,
            33300,
            4600
          ]
        },
        {
          lineData3: [
            8092,
            20728,
            54045,
            28348,
            52808,
            56097,
            49867,
            34715,
            48444,
            30415,
            46061,
            52677,
            69521,
            67560,
            48092
          ],
          lineData1: [
            18092,
            20728,
            24045,
            28348,
            32808,
            36097,
            39867,
            44715,
            28444,
            50415,
            56061,
            62677,
            59521,
            67560,
            18092
          ],
          lineData2: [
            4600,
            5000,
            5500,
            6500,
            7500,
            8500,
            9900,
            12500,
            14000,
            41500,
            23200,
            24450,
            35250,
            53300,
            4600
          ]
        },
        {
          lineData2: [
            8092,
            20728,
            54045,
            28348,
            52808,
            36097,
            49867,
            34715,
            28444,
            30415,
            46061,
            42677,
            69521,
            67560,
            48092
          ],
          lineData3: [
            18092,
            20728,
            24045,
            28348,
            32808,
            36097,
            39867,
            44715,
            48444,
            20415,
            56061,
            62677,
            59521,
            67560,
            18092
          ],
          lineData1: [
            4600,
            5000,
            5500,
            6500,
            7500,
            8500,
            9900,
            12500,
            34000,
            21500,
            23200,
            24450,
            25250,
            33300,
            4600
          ]
        }
      ]
    };
  },
  components: {
    Chart,
  },
  mounted() {
    this.title = 'device 左上'
    // this.changeData(this.data)
  },
  methods: {
    changeData(data, timeout = 3000) {
      if (this.title) {
        // console.log(this.title, this.index)
      }
      let index = this.index >= data.length ? 0 : this.index
      // 更新数据
      this.cdata.lineData1 = this.data[index].lineData1
      this.cdata.lineData2 = this.data[index].lineData2
      this.cdata.lineData3 = this.data[index].lineData3

      index ++
      this.index = index
      this.timeoutIndex = setTimeout(() => {
        this.changeData(data)
      }, timeout)
    }
  }
};
</script>

<style lang="scss" scoped>

</style>